import { TypePolicy } from "@apollo/client";

import { lastView, sumProgress } from "../../util/cache";

export default {
  merge: true,
  fields: {
    progress: {
      read: (_, { readField }) => sumProgress("slides", readField),
    },
    lastView: {
      read: (_, { readField }) => lastView("slides", readField),
    },
  },
} as TypePolicy;
